import React, { useEffect, useState } from 'react';
import { combineClassNames } from '../../../css';
import { useTheme } from '../../Theme';
export const AccordionGroupContext = React.createContext({
    isOpen: false,
    onToggle: () => {
        return;
    },
    displayOnly: false
});
const AccordionGroup = ({ className = 'cv-accordion__item', onToggle, isOpenDefault = false, displayOnly = false, id, children }) => {
    const theme = useTheme();
    const [styles, setStyles] = useState(null);
    const [accordionState, setAccordionState] = useState({
        isOpen: isOpenDefault,
        onToggle: () => {
            setAccordionState((prevState) => (Object.assign(Object.assign({}, prevState), { isOpen: !prevState.isOpen })));
            onToggle && onToggle();
        },
        displayOnly
    });
    useEffect(() => {
        import(`./styles/${theme}.scss`).then((styles) => {
            setStyles(styles);
        });
    }, []);
    return (React.createElement(React.Fragment, null, styles && (React.createElement("div", { className: combineClassNames([
            'cv-accordion__item',
            className !== 'cv-accordion__item' ? className : '',
            accordionState.isOpen ? `${className}--active` : ''
        ]), "aria-expanded": accordionState.isOpen, id: id },
        React.createElement(AccordionGroupContext.Provider, { value: accordionState }, children)))));
};
export default AccordionGroup;
//# sourceMappingURL=AccordionGroup.js.map